import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["list", "loadingIndicator", "scrollTrigger"]

  connect() {
    this.isLoading = false;
    this.currentPage = 1;
    this.totalPages = 1;
    this.hasMore = false;

    if (this.hasScrollTriggerTarget) {
      this.currentPage = parseInt(this.scrollTriggerTarget.dataset.currentPage, 10) || 1;
      this.totalPages = parseInt(this.scrollTriggerTarget.dataset.totalPages, 10) || 1;
      this.hasMore = this.currentPage < this.totalPages;

      if (this.hasMore) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && this.hasMore && !this.isLoading) {
              this.loadNextPage();
            }
          });
        }, {
          rootMargin: "200px",
          threshold: 0.1
        });

        this.observer.observe(this.scrollTriggerTarget);
      }
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta && meta.content;
  }

  showToast(message) {
    window.dispatchEvent(new CustomEvent("toast:show", {
      detail: { message }
    }));
  }

  async loadNextPage() {
    if (this.isLoading || !this.hasMore) return;

    this.isLoading = true;
    const nextPage = this.currentPage + 1;

    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.style.display = "block";
    }

    try {
      const response = await fetch(`/admin/jungle/payment-links/page?page=${nextPage}`, {
        method: "GET",
        headers: {
          Accept: "text/html",
          "X-CSRF-Token": this.csrfToken
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load page: ${response.status}`);
      }

      const html = await response.text();

      if (html.trim().length === 0) {
        this.hasMore = false;
      } else if (this.hasListTarget) {
        this.listTarget.insertAdjacentHTML("beforeend", html);
        this.currentPage = nextPage;
        this.hasMore = this.currentPage < this.totalPages;
      }

      if (!this.hasMore && this.hasScrollTriggerTarget) {
        this.scrollTriggerTarget.style.display = "none";
      }
    } catch (error) {
      console.error("Error loading jungle payment links:", error);
      this.showToast("Could not load more payment links");
    } finally {
      this.isLoading = false;

      if (this.hasLoadingIndicatorTarget) {
        this.loadingIndicatorTarget.style.display = "none";
      }
    }
  }
}
